import { useStyletron } from 'baseui'

const CounterBadge = ({ pdlType, pdlState }) => {
  const [css] = useStyletron()
  const isActive = pdlState === 'En service'
  const badgeColor = isActive ? '#aac031' : '#aaabaf'

  return (
    <div
      className={css({
        backgroundColor: badgeColor,
        borderRadius: '0.25rem',
        padding: '0.25rem 0.5rem',
        color: 'white',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
      })}
    >
      <span>{pdlType || 'Linky'}</span>
      <span>{pdlState || 'En service'}</span>
    </div>
  )
}

export default CounterBadge
